export const IGNORE_SURVEY_QUESTIONS: { [id: string]: string[] } = {
  PHQ_9: ['q10-1', 'q10-2'],
};
export const ignoreQuestionIdx = (name: string, qId: string) => !!IGNORE_SURVEY_QUESTIONS[name]?.some(v => v === qId);
